import {Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {TokenWithInvitation} from "../entities/token-with-invitation";
import {useEffect, useState} from "react";
import {TokenRevokeAccessDialog} from "./TokenRevokeAccessDialog";
import {useAuth} from "react-oidc-context";
import {useSnackbar} from "notistack";
import {TokenGiveAccessDialog} from "./TokenGiveAccessDialog";

export interface TokensWithInvitationProps {
    tokens: TokenWithInvitation[];
    showAdminInfos: boolean;
    tokenRevoked?: () => void
    tokenUsed?: () => void
}

export const TokensWithInvitationAndActions = ({
                                                   tokens,
                                                   showAdminInfos,
                                                   tokenUsed,
                                                   tokenRevoked
                                               }: TokensWithInvitationProps) => {

    const {isAuthenticated, user} = useAuth()
    const [openRevokeDialog, setOpenRevokeDialog] = useState(false);
    const [openGiveAccessDialog, setOpenGiveAccessDialog] = useState(false);
    const [tokenDialog, setTokenDialog] = useState<TokenWithInvitation>();
    const {enqueueSnackbar} = useSnackbar();
    const [streams, setStreams] = useState({})

    useEffect(() => {
        fetch("/api/invitations/available-streams", {headers: {"Authorization": `Bearer ${user?.access_token}`}})
            .then(res => res.json())
            .then((data: { [key: string]: string }) => {
                setStreams(data)
            })
            .catch(err => console.log(err))
    }, [user, setStreams])

    const revokeToken = (token: TokenWithInvitation) => {
        setTokenDialog(token)
        setOpenRevokeDialog(true)
    }

    const inviteUsingToken = (token: TokenWithInvitation) => {
        setTokenDialog(token)
        setOpenGiveAccessDialog(true)
    }

    const handleDialogClose = (token?: TokenWithInvitation) => {
        if (!!token) {
            sendRevocation(token).then(() => {
                setOpenRevokeDialog(false)
                tokenRevoked && tokenRevoked()
            })
        } else {
            setOpenRevokeDialog(false)
        }
    }

    const sendRevocation = async (token: TokenWithInvitation) => {
        if (!isAuthenticated) {
            enqueueSnackbar("Unable to send revocation request, refreshing token", {variant: "error"})
            window.location.reload()
        }
        const response = await fetch(`/api/invitations/${token.invitationId}`, {
                method: "DELETE", headers: {"Authorization": `Bearer ${user?.access_token}`}
            }
        )
        if (response.status >= 400) {
            enqueueSnackbar("An error has occurred while revoking the access", {variant: "error"})
        } else {
            tokenRevoked && tokenRevoked()
            enqueueSnackbar("Revoked access to the academy", {variant: "success"})
        }
    }

    const handleGiveAccessDialogClose = (token?: TokenWithInvitation) => {
        if (!!token) {
            console.log(token)
            fetch(`/api/invitations`, {
                method: 'POST',
                headers: {"Authorization": `Bearer ${user?.access_token}`, "Content-Type": "application/json"},
                body: JSON.stringify({
                    firstname: token.inviteeFirstname,
                    lastname: token.inviteeLastname,
                    email: token.inviteeEmail,
                    streamName: token.streamName,
                    streamID: token.streamId,
                    tokenId: token.id
                })
            }).then(async (res) => {
                if (res.status >= 300) {
                    enqueueSnackbar(`An error has occurred while inviting the participant ${await res.text()}`, {variant: "error"})
                } else {
                    enqueueSnackbar("Successfully invited the participant", {variant: "success"})
                    tokenUsed && tokenUsed()
                }
            }).catch(err => {
                console.log(err)
            }).finally(() => {
                setOpenGiveAccessDialog(false)
            })

            /*invite(token).then(() => {
            })*/
        } else {
            setOpenGiveAccessDialog(false)
        }

    }

    const getActionsForToken = (token: TokenWithInvitation) => {
        if (token.status === 'AVAILABLE') {
            return <Button onClick={() => inviteUsingToken(token)}>Invite</Button>
        } else if (token.status === 'SENT') {
            return <Button onClick={() => revokeToken(token)}>Revoke</Button>
        } else {
            return <></>
        }
    }

    return (
        <>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Paid token ?</TableCell>
                            {showAdminInfos &&
                                <><TableCell>Update date</TableCell>
                                    <TableCell>Update user</TableCell></>
                            }
                            <TableCell>Status</TableCell>
                            <TableCell>Invitee email</TableCell>
                            <TableCell>Course stream</TableCell>
                            <TableCell>End of Validity</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tokens?.map((token) =>
                            <TableRow hover key={token.id}>
                                <TableCell>{token.id}</TableCell>
                                <TableCell>{token.isPaidToken ? "PAID" : "FREE"}</TableCell>
                                {showAdminInfos &&
                                    <>
                                        <TableCell>{new Date(token.lastModifiedAt).toLocaleString("fr-be")}</TableCell>
                                        <TableCell>{token.lastModifiedBy}</TableCell>
                                    </>}
                                <TableCell>{token.status}</TableCell>
                                {token.status !== 'AVAILABLE' && <>
                                    <TableCell>{token.inviteeEmail}</TableCell>
                                    <TableCell>{token.streamName}</TableCell>
                                    <TableCell>{new Date(token.validityEndDate).toLocaleString("fr-be")}</TableCell>
                                </>}
                                {token.status === 'AVAILABLE' && <>
                                    <TableCell>N/A</TableCell>
                                    <TableCell>N/A</TableCell>
                                    <TableCell>N/A</TableCell>
                                </>}
                                <TableCell>{getActionsForToken(token)}</TableCell>
                            </TableRow>)}

                    </TableBody>
                </Table>
            </TableContainer>
            {openRevokeDialog &&
                <TokenRevokeAccessDialog token={tokenDialog} open={openRevokeDialog} onClose={handleDialogClose}/>}
            {openGiveAccessDialog &&
                <TokenGiveAccessDialog token={tokenDialog} open={openGiveAccessDialog} availableStreams={streams}
                                       onClose={handleGiveAccessDialogClose}/>}
        </>)
}